// src/pages/micuenta/DetallesEmpleo.jsx
import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import MiCuentaEmpleadorMenu from "./MiCuentaEmpleadorMenu";
import "./detallesempleo.css";

function DetallesEmpleo() {
  const { user } = useContext(AuthContext);
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);

  useEffect(() => {
    const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
    const foundJob = storedJobs.find(
      (job) => job.id.toString() === jobId
    );
    setJob(foundJob);
  }, [jobId]);

  if (!user || user.userType !== "employer") {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Acceso denegado</h2>
          <p>Debes ser empleador para ver esta sección.</p>
        </div>
      </div>
    );
  }

  if (!job) {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Empleo no encontrado</h2>
        </div>
      </div>
    );
  }

  const handleEdit = () => {
    navigate(`/mi-cuenta/empleos-publicados/editar/${job.id}`);
  };

  const handleDelete = () => {
    if (
      window.confirm(
        "¿Estás seguro que deseas eliminar esta publicación?\nSi: se moverá a la basura y se eliminará automáticamente después de 30 días.\nNo: se cancelará."
      )
    ) {
      const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
      const updatedJobs = storedJobs.filter((j) => j.id.toString() !== jobId);
      localStorage.setItem("jobs", JSON.stringify(updatedJobs));

      const trash = JSON.parse(localStorage.getItem("jobsTrash")) || [];
      const jobToDelete = { ...job, deletionDate: Date.now() };
      localStorage.setItem("jobsTrash", JSON.stringify([...trash, jobToDelete]));

      alert("Publicación eliminada y movida a la basura.");
      navigate(-1);
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        <MiCuentaEmpleadorMenu user={user} />

        <h2 className="detalles-title">{job.title}</h2>
        <div className="detalles-info">
          <p><strong>Descripción:</strong> {job.description}</p>
          <p><strong>Requisitos:</strong> {job.requirements}</p>
          <p><strong>Beneficios:</strong> {job.benefits}</p>
          <p><strong>Categoría:</strong> {job.category}</p>
          <p><strong>Subcategoría:</strong> {job.subcategory}</p>
          <p><strong>Estado (EE.UU.):</strong> {job.stateUS}</p>
          <p><strong>Ciudad:</strong> {job.city}</p>
          <p><strong>Zip Code:</strong> {job.zipCode}</p>
          <p><strong>Modalidad:</strong> {job.modality}</p>
          <p><strong>Idioma del Trabajo:</strong> {job.workLanguage}</p>
          <p><strong>Requisito de Visa:</strong> {job.visaRequirement}</p>
          <p><strong>Tipo de Trabajo:</strong> {job.jobType}</p>
          <p><strong>Salario:</strong> {job.salary}</p>
          <p><strong>Destacado:</strong> {job.highlight ? "Sí" : "No"}</p>
          <p><strong>Teléfono de Contacto:</strong> {job.phone || "No proporcionado"}</p>
          <p><strong>Correo de Contacto:</strong> {job.contactEmail || "No proporcionado"}</p>
          <p><strong>Fecha de publicación:</strong> {job.datePosted}</p>
          <p><strong>Estado de la Oferta:</strong> {job.status}</p>
        </div>

        <div className="detalles-actions row">
          <div className="col-12 col-sm-auto">
            <button onClick={() => navigate(-1)} className="btn btn-back">
              Volver
            </button>
          </div>
          <div className="col-12 col-sm-auto">
            <button
              onClick={() => navigate(`/mi-cuenta/candidatos?jobId=${job.id}`)}
              className="btn btn-view-candidates"
            >
              Ver Candidatos
            </button>
          </div>
          <div className="col-12 col-sm-auto">
            <button onClick={handleEdit} className="btn btn-edit">
              Editar
            </button>
          </div>
          <div className="col-12 col-sm-auto">
            <button onClick={handleDelete} className="btn btn-delete">
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetallesEmpleo;